export * from './full-layout.component';



// WEBPACK FOOTER //
// /app/src/app/containers/full-layout/index.ts